<!--Blocco principale-->
<div class="row">
    <div class="d-flex">
        <h3>
            <a title="Visualizza pagina" class="btn btn-lg pr-0 blu" href="{{pageUrl}}" target="_blank" rel="noopener">
                <i class="fas fa-external-link-alt"></i>
                {{titleStore}}
            </a>
        </h3>
    </div>

</div>
<div class="row">
    <form [formGroup]="formBuilder">
        <div class="row px-0 mx-0">
            <div class="blocks pt-0 px-0">
                <!--Tabs-->
                <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button (click)="changeTabs('store')" [ngClass]="{'active': tabs.store === 'active'}"
                            class="nav-link nav-fw" id="store-tab" data-bs-toggle="tab" data-bs-target="#store"
                            type="button" role="tab" aria-controls="store" aria-selected="false">Store e
                            impostazioni</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button (click)="changeTabs('location')" [ngClass]="{'active': tabs.location === 'active'}"
                            class="nav-link nav-fw" id="location-tab" data-bs-toggle="tab" data-bs-target="#location"
                            type="button" role="tab" aria-controls="location" aria-selected="false">Location e
                            orari</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button (click)="changeTabs('storemanager')"
                            [ngClass]="{'active': tabs.storemanager === 'active'}" class="nav-link nav-fw"
                            id="storemanager-tab" data-bs-toggle="tab" data-bs-target="#storemanager" type="button"
                            role="tab" aria-controls="storemanager" aria-selected="false">
                            Store manager
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button (click)="changeTabs('flags')" [ngClass]="{'active': tabs.flags === 'active'}"
                            class="nav-link nav-fw" id="flags-tab" data-bs-toggle="tab" data-bs-target="#flags"
                            type="button" role="tab" aria-controls="flags" aria-selected="true">Flags</button>
                    </li>
                </ul>
                <div class="tab-content " id="myTabContent">

                    <!-- STORE -->
                    <div [ngClass]="{'active': tabs.store === 'active' , 'fade': tabs.store !== 'active'}"
                        class="tab-pane fade show active" id="store" role="tabpanel" aria-labelledby="store-tab">
                        <div class="row pt-4 ps-4">
                            <div class="d-inline">
                                <i class="far fa-edit block-icons mx-2"></i>
                                <span class="card-title">Gestisci store</span>
                            </div>
                        </div>

                        <div class="row pt-4 ps-4">
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_comsy" class="form-label label-fw">
                                        Comsycode (comsycode)
                                    </label>
                                    <input formControlName="comsy" name="comsy" type="text"
                                        class="form-control form-fw " id="field_comsy" placeholder="Comsycode">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="fild_chainOfStores" class="form-label label-fw">
                                        Catena dello store (chainofStores)
                                    </label>
                                    <input formControlName="chainOfStores" name="chainOfStores" type="text"
                                        class="form-control form-fw " id="fild_chainOfStores"
                                        placeholder="ChainOfStores">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_dealerCategory" class="form-label label-fw">
                                        Categoria Dealer (campo: dealerCategory)
                                    </label>
                                    <input formControlName="dealerCategory" name="dealerCategory" type="text"
                                        class="form-control form-fw " id="field_dealerCategory"
                                        placeholder="DealerCategory">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_dealerDescription" class="form-label label-fw">
                                        Descrizione Dealer (campo: dealerDescription)
                                    </label>
                                    <input formControlName="dealerDescription" name="dealerDescription" type="text"
                                        class="form-control form-fw " id="field_dealerDescription"
                                        placeholder="DealerDescription">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_email" class="form-label label-fw">
                                        Email
                                    </label>
                                    <input formControlName="email" name="email" type="text"
                                        class="form-control form-fw " id="field_email" placeholder="Email">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_telephone" class="form-label label-fw">
                                        Telefono
                                    </label>
                                    <input formControlName="telephone" name="telephone" type="text"
                                        class="form-control form-fw " id="field_telephone" placeholder="Telephone">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_googlePlace" class="form-label label-fw">
                                        Google Places (campo: googlePlaces)
                                    </label>
                                    <input formControlName="googlePlace" name="googlePlace" type="text"
                                        class="form-control form-fw " id="field_googlePlace" placeholder="GooglePlace">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_googlePlus" class="form-label label-fw">
                                        Google Plus
                                    </label>
                                    <input formControlName="googlePlus" name="googlePlus" type="text"
                                        class="form-control form-fw " id="field_googlePlus" placeholder="GooglePlus">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_resellerLink" class="form-label label-fw">
                                        Link Reseller (campo: resellerLink)
                                    </label>
                                    <input formControlName="resellerLink" name="resellerLink" type="text"
                                        class="form-control form-fw " id="field_resellerLink"
                                        placeholder="ResellerLink">
                                </div>
                            </div>
                        </div>
                        <div class="row pt-4 px-4">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_seoid" class="form-label label-fw">
                                        seo ID
                                    </label>
                                    <input formControlName="seoId" name="seoId" type="text"
                                        class="form-control form-fw " id="field_seoid" placeholder="seoId">
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_titleSeo" class="form-label label-fw">
                                        Title SEO
                                    </label>
                                    <input formControlName="titleSeo" name="titleSeo" type="text"
                                        class="form-control form-fw "
                                        [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.titleSeo.errors}"
                                        id="field_titleSeo" placeholder="TitleSeo">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_seoDescription" class="form-label label-fw">
                                        Descrizione SEO
                                    </label>
                                    <textarea formControlName="seoDescription" name="seoDescription"
                                        class="form-control area" id="field_seoDescription" name="seoDescription"
                                        rows="5">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-4 px-4">
                            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <div class="d-flex">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_hasEquipmentWithdrawalExcluded">
                                                has Equipment With drawal Excluded (campo:
                                                hasEquipmentWithdrawalExcluded)
                                            </label>
                                        </div>
                                        <div class="justify-content-end form-switch">
                                            <label class="switch">
                                                <input formControlName="hasEquipmentWithdrawalExcluded"
                                                    name="hasEquipmentWithdrawalExcluded"
                                                    id="field_hasEquipmentWithdrawalExcluded" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-4 px-4">
                            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <div class="d-flex">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_findomesticMonthlyPaymentFw">Finanziamento Findomestic
                                            </label>
                                        </div>
                                        <div class="justify-content-end form-switch">
                                            <label class="switch">
                                                <input formControlName="findomesticMonthlyPaymentFw"
                                                    name="findomesticMonthlyPaymentFw"
                                                    id="field_findomesticMonthlyPaymentFw" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-4 px-4">
                            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <div class="d-flex">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_findomesticStatus">Findomestic Status </label>
                                        </div>
                                        <div class="justify-content-end form-switch">
                                            <label class="switch">
                                                <input formControlName="findomesticStatus" name="findomesticStatus"
                                                    id="field_findomesticStatus" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_galleryIds" class="form-label label-fw">
                                        Galleria immagini
                                    </label>
                                    <ng-autocomplete #galleryIds placeholder="Cerca galleria"
                                        [data]="galleryIds_Suggestion" [searchKeyword]="galleryIds_Keyword"
                                        (selected)='selectEvent_galleryIds($event)'
                                        (inputChanged)='getList_galleryIds($event)'
                                        (inputFocused)='onFocused_GalleryIds($event)'
                                        [itemTemplate]="itemTemplate_GalleryIds"
                                        (inputCleared)="searchGalleryIdsCleared()"
                                        [notFoundTemplate]="notFoundGalleryIdsTemplate" [debounceTime]="600"
                                        [formControl]="initialGalleryIdsValue"
                                        [isLoading]="isGalleryIdsKeywordLoadingResult" [minQueryLength]="2">
                                    </ng-autocomplete>
                                    <ng-template #itemTemplate_GalleryIds let-item>
                                        <div class="col-12">
                                            <div class="mx-3">
                                                <span [innerHTML]="item.name"></span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template #notFoundGalleryIdsTemplate let-notFound>
                                        {{errorMsg}}
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_storeDescription" class="form-label label-fw">
                                        Descrizione completa del negozio (Store Description)
                                    </label>
                                    <ckeditor #storeDescription="ngModel" [(ngModel)]="storeDescriptionValue"
                                        [ngModelOptions]="{standalone: true}" name="storeDescription"
                                        [config]="ckeConfig" debounce="500" (ngModelChange)="change($event)">
                                    </ckeditor>
                                </div>
                            </div>
                        </div>

                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_facebookLink" class="form-label label-fw">
                                        Link Pagina Facebook (campo: facebookLink)
                                    </label>
                                    <input formControlName="facebookLink" name="facebookLink" type="text"
                                        class="form-control form-fw " id="field_facebookLink"
                                        placeholder="FacebookLink">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_reservationLink" class="form-label label-fw">
                                        Link prenota ingresso
                                    </label>
                                    <input formControlName="reservationLink" name="reservationLink" type="text"
                                        class="form-control form-fw " id="field_reservationLink"
                                        placeholder="ReservationLink">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_whatsapp" class="form-label label-fw">
                                        Telefono per WhatsApp (Inserire anche prefisso es: 39XXXXXXXX)
                                    </label>
                                    <input formControlName="whatsapp" name="whatsapp" type="text"
                                        class="form-control form-fw " id="field_whatsapp" placeholder="Whatsapp">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_whatsappAddress" class="form-label label-fw">
                                        Indirizzo per WhatsApp (sovrascrive l'indirizzo normalizzato nel link)
                                    </label>
                                    <input formControlName="whatsappAddress" name="whatsappAddress" type="text"
                                        class="form-control form-fw " id="field_whatsappAddress" placeholder="WhatsappAddress">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_messengerLink" class="form-label label-fw">
                                        Link Messenger Facebook
                                    </label>
                                    <input formControlName="messengerLink" name="messengerLink" type="text"
                                        class="form-control form-fw " id="field_messengerLink"
                                        placeholder="MessengerLink">
                                </div>
                            </div>
                        </div>


                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_internalGalleryIds" class="form-label label-fw">
                                        Lista comodità cliente in negozio
                                    </label>
                                    <ng-autocomplete #accessoryIds placeholder="Cerca accessorio"
                                        [data]="accessoryIds_Suggestion" [searchKeyword]="accessoryIds_Keyword"
                                        (selected)='selectEvent__accessoryIds($event)'
                                        (inputChanged)='getList_accessoryIds($event)'
                                        (inputFocused)='onFocused__accessoryIds($event)'
                                        [itemTemplate]="itemTemplate_accessoryIds"
                                        (inputCleared)="searchCleared__accessoryIds()"
                                        [notFoundTemplate]="notFoundTemplate_accessoryIds" [debounceTime]="600"
                                        [isLoading]="accessoryIds_isKeywordLoadingResult" [minQueryLength]="2">
                                    </ng-autocomplete>
                                    <ng-template #itemTemplate_accessoryIds let-item>
                                        <div class="col-12">
                                            <div class="mx-3">
                                                <span [innerHTML]="item.name"></span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template #notFoundTemplate_accessoryIds let-notFound>
                                        {{errorMsg_accessoryIds}}
                                    </ng-template>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <fieldset class="fieldset-fw" [hidden]="accessoryIds_Selected.length === 0">
                                        <legend hidden></legend>
                                        <app-draggable-list-chip [draggable]="false" [itemList]="accessoryIds_Selected"
                                            [labelKeys]="labelKeys_accessoryIds"
                                            (changeItemList)="onChangeItemList_accessoryIds($event)">
                                        </app-draggable-list-chip>
                                    </fieldset>
                                </div>
                            </div>
                        </div>

                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="field_internalGalleryIds" class="form-label label-fw">
                                        Galleria interno negozio
                                    </label>
                                    <ng-autocomplete #internalGalleryIds placeholder="Cerca galleria"
                                        [data]="internalGalleryIds_Suggestion"
                                        [searchKeyword]="internalGalleryIds_Keyword"
                                        (selected)='selectEvent_internalGalleryIds($event)'
                                        (inputChanged)='getList_internalGalleryIds($event)'
                                        (inputFocused)='onFocused__InternalGalleryIds($event)'
                                        [itemTemplate]="itemInternalGalleryIdsTemplate"
                                        (inputCleared)="searchInternalGalleryIdsCleared()"
                                        [notFoundTemplate]="notFoundInternalGalleryIdsTemplate" [debounceTime]="600"
                                        [formControl]="initialInternalGalleryIdsValue"
                                        [isLoading]="isInternalGalleryIdsKeywordLoadingResult" [minQueryLength]="2">
                                    </ng-autocomplete>
                                    <ng-template #itemInternalGalleryIdsTemplate let-item>
                                        <div class="col-12">
                                            <div class="mx-3">
                                                <span [innerHTML]="item.name"></span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template #notFoundInternalGalleryIdsTemplate let-notFound>
                                        {{errorMsgInternalGalleryIds}}
                                    </ng-template>
                                </div>
                            </div>
                        </div>




                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="" class="form-label label-fw">
                                        Prodotti e Servizi
                                    </label>
                                    <ng-autocomplete #productAndServices placeholder="Cerca Prodotti e servizi"
                                        [data]="productAndServices_Suggestion"
                                        [searchKeyword]="productAndServices_Keyword"
                                        (selected)='selectEvent__productAndServices($event)'
                                        (inputChanged)='getList_productAndServices($event)'
                                        (inputFocused)='onFocused__productAndServices($event)'
                                        (inputCleared)="searchCleared__productAndServices()"
                                        [itemTemplate]="itemTemplate_productAndServices"
                                        [notFoundTemplate]="notFoundTemplate_productAndServices" [debounceTime]="600"
                                        [isLoading]="productAndServices_isKeywordLoadingResult" [minQueryLength]="2">
                                    </ng-autocomplete>
                                    <ng-template #itemTemplate_productAndServices let-item>
                                        <div class="col-12">
                                            <div class="mx-3">
                                                <span [innerHTML]="item.serviceName"></span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template #notFoundTemplate_productAndServices let-notFound>
                                        {{errorMsg_productAndServices}}
                                    </ng-template>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <fieldset class="fieldset-fw" [hidden]="productAndServices_Selected.length === 0">
                                        <legend hidden></legend>
                                        <app-draggable-list-chip [draggable]="false"
                                            [itemList]="productAndServices_Selected"
                                            [labelKeys]="labelKeys_productAndServices"
                                            (changeItemList)="onChangeItemList_productAndServices($event)">
                                        </app-draggable-list-chip>
                                    </fieldset>
                                </div>
                            </div>
                        </div>


                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="" class="form-label label-fw">
                                        Promozioni/Eventi
                                    </label>
                                    <ng-autocomplete #promozioneEventi placeholder="Cerca Promozioni o eventi"
                                        [data]="promozioneEventi_Suggestion" [searchKeyword]="promozioneEventi_Keyword"
                                        (selected)='selectEvent__promozioneEventi($event)'
                                        (inputChanged)='getList_promozioneEventi($event)'
                                        (inputFocused)='onFocused__promozioneEventi($event)'
                                        (inputCleared)="searchCleared__promozioneEventi()"
                                        [itemTemplate]="itemTemplate_promozioneEventi"
                                        [notFoundTemplate]="notFoundTemplate_promozioneEventi" [debounceTime]="600"
                                        [isLoading]="promozioneEventi_isKeywordLoadingResult" [minQueryLength]="2">
                                    </ng-autocomplete>
                                    <ng-template #itemTemplate_promozioneEventi let-item>
                                        <div class="col-12">
                                            <div class="mx-3">
                                                <span [innerHTML]="item.name"></span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template #notFoundTemplate_promozioneEventi let-notFound>
                                        {{errorMsg_promozioneEventi}}
                                    </ng-template>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <fieldset class="fieldset-fw" [hidden]="promozioneEventi_Selected.length === 0">
                                        <legend hidden></legend>
                                        <app-draggable-list-chip [draggable]="false"
                                            [itemList]="promozioneEventi_Selected"
                                            [labelKeys]="labelKeys_promozioneEventi"
                                            (changeItemList)="onChangeItemList_promozioneEventi($event)">
                                        </app-draggable-list-chip>
                                    </fieldset>
                                </div>
                            </div>
                        </div>


                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="m-3">
                                    <label for="" class="form-label label-fw">
                                        Documento
                                    </label>
                                    <ng-autocomplete #documentIds placeholder="Cerca Documenti"
                                        [data]="documentIds_Suggestion" [searchKeyword]="documentIds_Keyword"
                                        (selected)='selectEvent__documentIds($event)'
                                        (inputChanged)='getList_documentIds($event)'
                                        (inputFocused)='onFocused__documentIds($event)'
                                        (inputCleared)="searchCleared__documentIds()"
                                        [itemTemplate]="itemTemplate_documentIds"
                                        [notFoundTemplate]="notFoundTemplate_documentIds" [debounceTime]="600"
                                        [formControl]="initialDocumentValue"
                                        [isLoading]="documentIds_isKeywordLoadingResult" [minQueryLength]="2">
                                    </ng-autocomplete>
                                    <ng-template #itemTemplate_documentIds let-item>
                                        <div class="col-12">
                                            <div class="mx-3">
                                                <span [innerHTML]="item.name"></span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template #notFoundTemplate_documentIds let-notFound>
                                        {{errorMsg_documentIds}}
                                    </ng-template>
                                </div>
                            </div>
                        </div>


                        <div class="row pt-4 px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="col m-3">
                                    <label for="" class="form-label label-fw">
                                        Head image
                                    </label>
                                    <br>
                                    <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                                        (click)="openLoadImageFromPC()">
                                        Carica da PC
                                    </button>
                                    <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                                        (click)="openLoadImageFromDAM()">
                                        Carica da D.A.M.
                                    </button>
                                    <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                                        (click)="deleteImage()">
                                        Elimina
                                    </button>

                                    <div class="thumb-area d-flex justify-content-center my-3">
                                        <div class="icona justify-content-center" [hidden]="visibleImageChoice">
                                            <i class="fas fa-camera"></i>
                                        </div>
                                        <img [src]="imageChoice.url" alt="Anteprima"
                                            class="img-thumbnail img-thumbnail-dim" [hidden]="!visibleImageChoice">
                                    </div>

                                    <input type="text" formControlName="headImageId" name="headImageId" hidden>
                                </div>
                            </div>
                        </div>





                    </div>

                    <!-- LOCATION AND HOURS -->
                    <div [ngClass]="{'active': tabs.location === 'active' , 'fade': tabs.location !== 'active'}"
                        class="tab-pane" id="location" role="tabpanel" aria-labelledby="location-tab">

                        <ng-container formGroupName="location" #locationView>
                            <div class="row pt-4 ps-4">
                                <div class="d-inline">
                                    <i class="far fa-map-marker block-icons mx-2"></i>
                                    <span class="card-title">Location</span>
                                </div>
                            </div>

                            <div class="row pt-4 ps-2">
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="form-check mx-3 d-flex">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="field_streetViewEnabled">
                                                Street view attivato
                                            </label>
                                        </div>
                                        <div class="justify-content-end form-switch">
                                            <label class="switch">
                                                <input formControlName="streetViewEnabled" name="streetViewEnabled"
                                                    id="field_streetViewEnabled" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" hidden>
                                    <div class="">
                                        <a href="#"><span class="toggle-text links">Modifica posizione su
                                                mappa</span></a>
                                        <i class="far fa-map-marker mx-2"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="row pt-4 px-4">
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_address" class="form-label label-fw">
                                            Indirizzo (popShippingAddress)
                                        </label>
                                        <input formControlName="address" name="address" type="text"
                                            class="form-control form-fw" id="field_address" placeholder="Indirizzo">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_city" class="form-label label-fw">
                                            Città (popShippingCity)
                                        </label>
                                        <input formControlName="city" name="city" type="text"
                                            class="form-control form-fw " id="field_city" placeholder="Città">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_province" class="form-label label-fw">
                                            Provincia (popShippingProvince)
                                        </label>
                                        <input formControlName="province" name="province" type="text"
                                            class="form-control form-fw" id="field_province" placeholder="Provincia">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_region" class="form-label label-fw">
                                            Regione (popShippingRegion)
                                        </label>
                                        <input formControlName="region" name="region" type="text"
                                            class="form-control form-fw" id="field_region" placeholder="Regione">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_zip" class="form-label label-fw">
                                            CAP (popShippingZipCode)
                                        </label>
                                        <input formControlName="zip" name="zip" type="text"
                                            class="form-control form-fw " id="field_zip" placeholder="CAP">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_accuracy" class="form-label label-fw">Accuracy</label>
                                        <input formControlName="accuracy" name="accuracy" type="text"
                                            class="form-control form-fw" id="field_accuracy" placeholder="Accuracy">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_latitude" class="form-label label-fw">
                                            Latitudine
                                        </label>
                                        <input formControlName="latitude" name="latitude" type="text"
                                            class="form-control form-fw" id="field_latitude" placeholder="Latitudine">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_longitude" class="form-label label-fw">Longitudine</label>
                                        <input formControlName="longitude" name="longitude" type="text"
                                            class="form-control form-fw " id="field_longitude" placeholder="Palermo">
                                    </div>
                                </div>
                            </div>


                            <div class="row pt-4 px-4">

                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_streetViewLatitude" class="form-label label-fw">
                                            Latitudine (Street view)
                                        </label>
                                        <input formControlName="streetViewLatitude" name="streetViewLatitude"
                                            type="text" class="form-control form-fw" id="field_streetViewLatitude"
                                            placeholder="Latitudine (Street view)">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_streetViewLongitude" class="form-label label-fw">
                                            Longitudine (Street view)
                                        </label>
                                        <input formControlName="streetViewLongitude" name="streetViewLongitude"
                                            type="text" class="form-control form-fw " id="field_streetViewLongitude"
                                            placeholder="Longitudine (Street view) ">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_panoID" class="form-label label-fw">
                                            Pano ID (Street view)
                                        </label>
                                        <input type="text" class="form-control form-fw " id="field_panoID"
                                            name="streetViewPanoId" placeholder="Pano ID (Street View)"
                                            formControlName="streetViewPanoId">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_streetViewPitch" class="form-label label-fw">
                                            Pitch (Street view)
                                        </label>
                                        <input formControlName="streetViewPitch" name="streetViewPitch" type="text"
                                            class="form-control form-fw" id="field_streetViewPitch"
                                            placeholder="Pitch (Street view)">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_streetViewHeading" class="form-label label-fw">
                                            Heading (Street view)
                                        </label>
                                        <input formControlName="streetViewHeading" name="streetViewHeading" type="text"
                                            class="form-control form-fw" id="field_streetViewHeading"
                                            placeholder="Heading (Street view)">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_streetViewZoom" class="form-label label-fw">
                                            Zoom (Street view)
                                        </label>
                                        <input formControlName="streetViewZoom" name="streetViewZoom" type="text"
                                            class="form-control form-fw" id="field_streetViewZoom"
                                            placeholder="Zoom (Street view)">
                                    </div>
                                </div>

                            </div>



                            <div class="row pt-4 px-4">

                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_fullNormalizedAddress" class="form-label label-fw">
                                            Indirizzo normalizzato Completo
                                        </label>
                                        <input formControlName="fullNormalizedAddress" name="fullNormalizedAddress"
                                            type="text" class="form-control form-fw " id="field_fullNormalizedAddress"
                                            placeholder="Indirizzo normalizzato Completo">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedDug" class="form-label label-fw">
                                            Denominazione generica centralizzata
                                        </label>
                                        <input formControlName="normalizedDug" name="normalizedDug" type="text"
                                            class="form-control form-fw " id="field_normalizedDug" placeholder="DUG">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedAddress" class="form-label label-fw">
                                            Indirizzo normalizzato
                                        </label>
                                        <input formControlName="normalizedAddress" name="normalizedAddress" type="text"
                                            class="form-control form-fw" id="field_normalizedAddress"
                                            placeholder="Indirizzo normalizzato">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedHouseNumber" class="form-label label-fw">
                                            Numero civico normalizzato
                                        </label>
                                        <input formControlName="normalizedHouseNumber" name="normalizedHouseNumber"
                                            type="text" class="form-control form-fw " id="field_normalizedHouseNumber"
                                            placeholder="Numero civico normalizzato">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedZip" class="form-label label-fw">
                                            CAP normalizzato
                                        </label>
                                        <input formControlName="normalizedZip" name="normalizedZip" type="text"
                                            class="form-control form-fw" id="field_normalizedZip"
                                            placeholder="CAP normalizzato">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedCity" class="form-label label-fw">
                                            Città normalizzata
                                        </label>
                                        <input formControlName="normalizedCity" name="normalizedCity" type="text"
                                            class="form-control form-fw" id="field_normalizedCity"
                                            placeholder="Città normalizzata">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedHamlet" class="form-label label-fw">
                                            Frazione normalizzata
                                        </label>
                                        <input formControlName="normalizedHamlet" name="normalizedHamlet" type="text"
                                            class="form-control form-fw" id="field_normalizedHamlet"
                                            placeholder="Frazione normalizzata">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedProvince" class="form-label label-fw">
                                            Provincia normalizzata
                                        </label>
                                        <input formControlName="normalizedProvince" name="normalizedProvince"
                                            type="text" class="form-control form-fw " id="field_normalizedProvince"
                                            placeholder="Provincia normalizzata">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedRegion" class="form-label label-fw">
                                            Regione normalizzata
                                        </label>
                                        <input formControlName="normalizedRegion" name="normalizedRegion" type="text"
                                            class="form-control form-fw " id="field_normalizedRegion"
                                            placeholder="Regione normalizzata">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedCountry" class="form-label label-fw">
                                            Nazione normalizzata</label>
                                        <input formControlName="normalizedCountry" name="normalizedCountry" type="text"
                                            class="form-control form-fw " id="field_normalizedCountry"
                                            placeholder="Nazione normalizzata">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12"></div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12"></div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedLatitude" class="form-label label-fw">
                                            Latitudine normalizzata</label>
                                        <input formControlName="normalizedLatitude" name="normalizedLatitude"
                                            type="text" class="form-control form-fw " id="field_normalizedLatitude"
                                            placeholder="Latitudine normalizzata" (change)="changeCoordinates()">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_normalizedLongitude" class="form-label label-fw">
                                            Longitudine normalizzata</label>
                                        <input formControlName="normalizedLongitude" name="normalizedLongitude"
                                            type="text" class="form-control form-fw " id="field_normalizedLongitude"
                                            placeholder="Latitudine normalizzata" (change)="changeCoordinates()">
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 d-flex">
                                    <div class="d-flex" style="margin:auto;">
                                        <button type="button" class="btn btn-outline-fw mx-1 text btn-restorecoordinates" (click)="modifyCoordinates()">
                                            Modifica posizione
                                            <img alt="" src="/assets/images/google_maps.jpg" style="width: 20px;">
                                        </button>
                                        <button  type="button" class="btn btn-outline-fw mx-1 text btn-restorecoordinates"  (click)="resetCoordinates()" [disabled]="!isChangeCoordinates">Resetta coordinate</button>
                                    </div> 
                                </div>

                            </div>
                        </ng-container>

                        <ng-container #hoursView>
                            <div class="row my-4 ps-4">
                                <div class="d-inline">
                                    <i class="far fa-clock block-icons mx-2"></i>
                                    <span class="card-title">Orari</span>
                                </div>
                            </div>
                            <div class="row px-4">
                                <app-openingclosinghours-table [inputOpeningclosinghoursTable]="standardHours"
                                    [isOnlyView]="true">
                                </app-openingclosinghours-table>
                            </div>
                        </ng-container>

                    </div>

                    <!-- STOREMANAGER-->
                    <div [ngClass]="{'active': tabs.storemanager === 'active' , 'fade': tabs.storemanager !== 'active' }"
                        class="tab-pane fade" id="storemanager" role="tabpanel" aria-labelledby="location-tab">

                        <ng-container formGroupName="embeddedStoreManager" #embeddedStoreManagerView>
                            <div class="row my-4 ps-4">
                                <div class="d-inline">
                                    <i class="far fa-user block-icons mx-2"></i>
                                    <span class="card-title">Store manager</span>
                                </div>
                            </div>

                            <div class="row pt-4 ps-4">
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerName" class="form-label label-fw">
                                            Nome
                                        </label>
                                        <input formControlName="storeManagerName" name="storeManagerName" type="text"
                                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && embeddedStoreManagerControls.storeManagerName.errors}"
                                            class="form-control form-fw " id="field_storeManagerName"
                                            placeholder="StoreManagerName">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerSurname" class="form-label label-fw">
                                            Cognome
                                        </label>
                                        <input formControlName="storeManagerSurname" name="storeManagerSurname"
                                            type="text"
                                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && embeddedStoreManagerControls.storeManagerSurname.errors}"
                                            class="form-control form-fw " id="field_storeManagerSurname"
                                            placeholder="StoreManagerSurname">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerTelephone" class="form-label label-fw">
                                            Telefono
                                        </label>
                                        <input formControlName="storeManagerTelephone" name="storeManagerTelephone"
                                            type="text" class="form-control form-fw " id="field_storeManagerTelephone"
                                            placeholder="StoreManagerTelephone">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerEmail" class="form-label label-fw">
                                            Email
                                        </label>
                                        <input formControlName="storeManagerEmail" name="storeManagerEmail" type="text"
                                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && embeddedStoreManagerControls.storeManagerEmail.errors}"
                                            class="form-control form-fw " id="field_storeManagerEmail"
                                            placeholder="StoreManagerEmail">

                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerAlternativeEmail1" class="form-label label-fw">
                                            Email alternativa 1
                                        </label>
                                        <input formControlName="storeManagerAlternativeEmail1"
                                            name="storeManagerAlternativeEmail1" type="text"
                                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && embeddedStoreManagerControls.storeManagerAlternativeEmail1.errors}"
                                            class="form-control form-fw " id="field_storeManagerAlternativeEmail1"
                                            placeholder="storeManagerAlternativeEmail1">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerAlternativeEmail2" class="form-label label-fw">
                                            Email alternativa 2
                                        </label>
                                        <input formControlName="storeManagerAlternativeEmail2"
                                            name="storeManagerAlternativeEmail2" type="text"
                                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && embeddedStoreManagerControls.storeManagerAlternativeEmail2.errors}"
                                            class="form-control form-fw " id="field_storeManagerAlternativeEmail2"
                                            placeholder="storeManagerAlternativeEmail2">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerEmailXml" class="form-label label-fw">
                                            Email XML
                                        </label>
                                        <input formControlName="storeManagerEmailXml" name="storeManagerEmailXml"
                                            type="text" class="form-control form-fw " id="field_storeManagerEmailXml"
                                            placeholder="StoreManagerEmailXml">
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerGoogleProfile" class="form-label label-fw">
                                            Profilo Google
                                        </label>
                                        <input formControlName="storeManagerGoogleProfile"
                                            name="storeManagerGoogleProfile" type="text" class="form-control form-fw "
                                            id="field_storeManagerGoogleProfile"
                                            placeholder="storeManagerGoogleProfile">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="m-3">
                                        <label for="field_storeManagerBiography" class="form-label label-fw">
                                            Biografia
                                        </label>
                                        <ckeditor #storeManagerBiography="ngModel"
                                            [(ngModel)]="storeManagerBiographyValue"
                                            [ngModelOptions]="{standalone: true}" name="storeManagerBiography"
                                            [config]="ckeConfig" debounce="500" (ngModelChange)="change($event)">
                                        </ckeditor>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <!-- FLAGS-->
                    <div [ngClass]="{'active': tabs.flags === 'active' , 'fade': tabs.flags !== 'active'}"
                        class="tab-pane fade" id="flags" role="tabpanel" aria-labelledby="flags-tab">

                        <ng-container formGroupName="visibilityFlag" #visibilityFlagView>

                            <div class="row pt-4 ps-4">
                                <div class="d-inline">
                                    <i class="far fa-flag-alt block-icons mx-2"></i>
                                    <span class="card-title">Flags</span>
                                </div>
                            </div>

                            <div class="row pt-4 ps-2">

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityFullStoreDescription">
                                                Visibilità descrizione completa
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityFullStoreDescription"
                                                    name="visibilityFullStoreDescription"
                                                    id="field_visibilityFullStoreDescription" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityStoreManagerPhoto">
                                                Visibilità immagine Store Manager
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityStoreManagerPhoto"
                                                    name="visibilityStoreManagerPhoto"
                                                    id="field_visibilityStoreManagerPhoto" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityOpeningClosingTime">
                                                Visibilità orari
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityOpeningClosingTime"
                                                    name="visibilityOpeningClosingTime"
                                                    id="field_visibilityOpeningClosingTime" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="field_visibilityEvent">
                                                Visibilità eventi
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityEvent" name="visibilityEvent"
                                                    id="field_visibilityEvent" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="flexSwitchCheckChecked">
                                                Visibilità Google Places
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityGooglePlace"
                                                    name="visibilityGooglePlace" id="field_visibilityGooglePlace"
                                                    type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="field_visibilityServices">
                                                Visibilità servizi
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityServices" name="visibilityServices"
                                                    id="field_visibilityServices" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityStoreManagerTelephone">
                                                Visibilità telefono Store Manager
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityStoreManagerTelephone"
                                                    name="visibilityStoreManagerTelephone"
                                                    id="field_visibilityStoreManagerTelephone" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="field_visibilityPromotion">
                                                Visibilità promozioni
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityPromotion" name="visibilityPromotion"
                                                    id="field_visibilityPromotion" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="field_visibilityFacebook">
                                                Visibilità Facebook
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityFacebook" name="visibilityFacebook"
                                                    id="field_visibilityFacebook" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="field_visibilityEmail">
                                                Visibilità email
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityEmail" name="visibilityEmail"
                                                    id="field_visibilityEmail" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityStoreManager">
                                                Visibilità Store Manager
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityStoreManager"
                                                    name="visibilityStoreManager" id="field_visibilityStoreManager"
                                                    type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityScheduleAppointments">
                                                Visibilità fissa appuntamento
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityScheduleAppointments"
                                                    name="visibilityScheduleAppointments"
                                                    id="field_visibilityScheduleAppointments" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="field_visibilityTelephone">
                                                Visibilità telefono
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityTelephone" name="visibilityTelephone"
                                                    id="field_visibilityTelephone" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text" for="field_visibilityGallery">
                                                Visibilità galleria
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityGallery" name="visibilityGallery"
                                                    id="field_visibilityGallery" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityStoreManagerEmail">
                                                Visibilità email Store Manager
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityStoreManagerEmail"
                                                    name="visibilityStoreManagerEmail"
                                                    id="field_visibilityStoreManagerEmail" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityManageOpeningClosingTime">
                                                Visibilità Gestione Orari
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityManageOpeningClosingTime"
                                                    name="visibilityManageOpeningClosingTime"
                                                    id="field_visibilityManageOpeningClosingTime" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityClickAndCollectSim">
                                                Visibilità click & collect SIM
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityClickAndCollectSim"
                                                    name="visibilityClickAndCollectSim"
                                                    id="field_visibilityClickAndCollectSim" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityManageOpeningClosingTimeAppointments">
                                                Gestione orari appuntamenti
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityManageOpeningClosingTimeAppointments"
                                                    name="visibilityManageOpeningClosingTimeAppointments"
                                                    id="field_visibilityManageOpeningClosingTimeAppointments"
                                                    type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityClickAndCollectSmartphone">
                                                Visibilità click & collect SMARTPHONE
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityClickAndCollectSmartphone"
                                                    name="visibilityClickAndCollectSmartphone"
                                                    id="field_visibilityClickAndCollectSmartphone" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityInternalGallery">
                                                Visibilità Galleria interna
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityInternalGallery"
                                                    name="visibilityInternalGallery"
                                                    id="field_visibilityInternalGallery" type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityVideocallme">
                                                Visibilità Videochiamaci
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityVideocallme"
                                                    name="visibilityVideocallme" id="field_visibilityVideocallme"
                                                    type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-check form-switch d-flex m-3">
                                        <div class="justify-content-start w-100">
                                            <label class="form-check-label toggle-text"
                                                for="field_visibilityDigitalcoupon">
                                                Visibilità Digital Coupon
                                            </label>
                                        </div>
                                        <div class="justify-content-end">
                                            <label class="switch">
                                                <input formControlName="visibilityDigitalCoupon"
                                                    name="visibilityDigitalcoupon" id="field_visibilityDigitalcoupon"
                                                    type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </ng-container>

                    </div>
                    <!--Fine Tabs-->

                </div>
            </div>
        </div>



        <div class="row px-0 mx-0">
            <!-- Pubblicazione -->
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 mx-0">
                <div class="blocks my-3">
                    <div class="row pt-4 px-4">
                        <div class="d-inline">
                            <i class="far fa-eye block-icons mx-2"></i>
                            <span class="card-title">Visibilità</span>
                        </div>
                    </div>

                    <div class="row pt-4 ps-4">
                        <div class="label-fw mx-2 d-flex">
                            <div class="d-flex">
                                Stato di pubblicazione
                            </div>
                            <div class="form-check form-switch d-flex">
                                <div class="justify-content-end">
                                    <label class="switch">
                                        <input formControlName="published" name="published" id="field_published"
                                            type="checkbox">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="size-16 status-fw mx-2">
                            <ng-container>
                                <span [hidden]="!publishedView.published">
                                    <i class="fas fa-circle grn"></i>Online
                                </span>
                                <span [hidden]="publishedView.published">
                                    <i class="fas fa-circle red"></i>Offline
                                </span>
                            </ng-container>
                        </div>


                    </div>
                </div>
            </div>

            <!-- Informazioni generali-->
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 mx-0">
                <div class="blocks my-3">
                    <div class="row pt-4 px-4">
                        <div class="d-inline">
                            <i class="far fa-cog block-icons mx-2"></i>
                            <span class="card-title">System</span>
                        </div>
                    </div>

                    <div class="row pt-4 px-4">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="m-3">
                                <label for="field_createdAt" class="form-label label-fw">Data creazione</label>
                                <input value="{{systemView.createdAt}}" type="text" class="form-control form-fw "
                                    id="field_createdAt" placeholder="gg/mm/aaaa" disabled>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="m-3">
                                <label for="field_createdBy" class="form-label label-fw">Creato da</label>
                                <input value="{{systemView.createdBy}}" type="email" class="form-control form-fw "
                                    id="field_createdBy" placeholder="Creato da" disabled>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="m-3">
                                <label for="field_modifiedAt" class="form-label label-fw">
                                    Data ultima modifica
                                </label>
                                <input value="{{systemView.modifiedAt}}" type="text" class="form-control form-fw "
                                    id="field_modifiedAt" placeholder="gg/mm/aaaa" disabled>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="m-3">
                                <label for="field_modifiedBy" class="form-label label-fw">Modificato da</label>
                                <input value="{{systemView.modifiedBy}}" type="email" class="form-control form-fw "
                                    id="field_modifiedBy" placeholder="Modificato da" disabled>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Gestisci pubblicazione-->
        <div class="row px-0 mx-0">
            <div class="col px-0 mx-0">
                <div class="blocks my-3">
                    <div class="row">
                        <div class="d-inline">
                            <i class="far fa-tools block-icons mx-2"></i>
                            <span class="card-title">Gestisci pubblicazione</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="ms-2 mt-4">
                            <button type="button" class="btn btn-outline-fw text mr-15"
                                (click)="clickButtonGoBack()">Annulla</button>
                            <button type="button"
                                [disabled]="(form.status === 'INVALID' && form.touched === true)"
                                (click)="clickButtonSave()" class="btn btn-fw text me-3">Salva
                                modifiche</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </form>
</div>